import { useRef } from 'react';
import type { GoodsDetailTab } from '../types/GoodsDetailTab';
import { retainedState, useRetainedState } from 'shared/src/hooks/retainedState';

const tabState = retainedState<GoodsDetailTab>('INFORMATION');

export const useTab = () => useRetainedState(tabState)[0];

export const useSetTab = () => useRetainedState(tabState)[1];

/**
 * tab의 현재 값을 ref로 접근할 수 있는 훅.
 * 콜백 안에서 최신 tab 값을 참조할 때 사용.
 */
export const useTabRef = () => {
  const tab = useTab();
  const tabRef = useRef(tab);
  tabRef.current = tab;
  return tabRef;
};
